import React from "react";
import { Box, Card, Chip, LinearProgress, Typography } from "@mui/material";
import DashboardPanelHeader from "components/DashboardPanelHeader";
import { enterpriseTokens } from "styles/theme";

const HseThresholdMetric = ({ eyebrow, title, subtitle, value, unit = "", status, color, progress, benchmark }) => (
    <Card elevation={0} sx={{ height: "100%", border: `1px solid ${enterpriseTokens.lineSoft}`, borderRadius: "3px", overflow: "hidden" }}>
        <DashboardPanelHeader eyebrow={eyebrow} title={title} subtitle={subtitle} />
        <Box sx={{ p: 1.5 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1 }}>
                <Box>
                    <Typography sx={{ fontSize: "32px", lineHeight: "38px", fontWeight: 700, color: enterpriseTokens.navy }}>
                        {value}{unit}
                    </Typography>
                    <Typography sx={{ mt: 0.25, fontSize: "11px", color: enterpriseTokens.muted }}>{benchmark}</Typography>
                </Box>
                <Chip label={status} size="small" sx={{ height: 20, borderRadius: "999px", color, bgcolor: `${color}12`, border: `1px solid ${color}33`, fontSize: "8px", fontWeight: 700, textTransform: "uppercase" }} />
            </Box>
            <LinearProgress variant="determinate" value={Math.max(0, Math.min(progress, 100))} sx={{ mt: 2, height: 7, borderRadius: 0, backgroundColor: "#E2E8F0", "& .MuiLinearProgress-bar": { borderRadius: 0, backgroundColor: color } }} />
        </Box>
    </Card>
);

export default HseThresholdMetric;
